// LandlordToolkitCard.tsx - Card component for navigating to the Landlord Toolkit
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  WrenchScrewdriverIcon,
  ArrowRightIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

const LandlordToolkitCard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 rounded-2xl p-8 text-white shadow-xl hover:shadow-2xl transition-all">
      <div className="flex items-start justify-between mb-4">
        <div className="p-3 bg-white/10 backdrop-blur-sm rounded-xl">
          <WrenchScrewdriverIcon className="w-8 h-8 text-white" />
        </div>
        <div className="flex items-center gap-2 bg-yellow-400 text-blue-900 px-3 py-1 rounded-full text-xs font-bold">
          <SparklesIcon className="w-4 h-4" />
          <span>NEW</span>
        </div>
      </div>

      <h3 className="text-2xl font-bold mb-3">Landlord Toolkit</h3>

      <p className="text-blue-100 mb-6 leading-relaxed">
        Access powerful property management tools including rent tracking,
        automated reminders, tenant messaging, and more. Everything you need in
        one place.
      </p>

      <div className="space-y-2 mb-6">
        <div className="flex items-center gap-2 text-sm text-blue-100">
          <svg
            className="w-5 h-5 text-green-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          <span>Rent Payment Tracker</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-blue-100">
          <svg
            className="w-5 h-5 text-green-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          <span>Automated Late Reminders</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-blue-100">
          <svg
            className="w-5 h-5 text-green-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          <span>Tenant Communication Hub</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-blue-100">
          <svg
            className="w-5 h-5 text-yellow-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
          <span>More features coming soon...</span>
        </div>
      </div>

      <button
        onClick={() => navigate('/landlord-toolkit')}
        className="group w-full bg-white text-blue-600 py-3 px-6 rounded-lg font-semibold hover:bg-blue-50 transition-all flex items-center justify-center gap-2"
      >
        <span>Explore Toolkit</span>
        <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
      </button>
    </div>
  );
};

export default LandlordToolkitCard;
